import React, { useContext, useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { Table, Input, Button, Radio, Form, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import "./RecipeAddTableWidget.css";
import { getCurrencyInfo } from "utils/GlobalFunctions";
import dragula from "dragula";
import "dragula/dist/dragula.css";
import { DragOutlined } from "@ant-design/icons";

const getIndexInParent = (el) => Array.from(el.parentNode.children).indexOf(el);

function RecipeAddTableWidget(props) {
  const [isBusy, setIsBusy] = useState(false);
  const { dataList, handleDelete, handleEdit, ownCommonData, dataSource, setDataSource } =
    props;

  useEffect(() => {
    let start;
    let end;
    const container = document.querySelector(".ant-table-tbody");
    const drake = dragula([container], {
      moves: (el) => {
        start = getIndexInParent(el);
        return true;
      },
    });

    drake.on("drop", (el) => {
      end = getIndexInParent(el);
      handleReorder(start, end);
    });
  }, []);

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([
        ...dataList.map((info) => {
          return { ...info, key: info.id, icon: <DragOutlined type="swap" /> };
        }),
      ]);
    }
  }, [dataList]);

  if (dataList === undefined) return <div />;
  const columns = [
    {
      title: <DragOutlined type="swap" />,
      dataIndex: "icon",
    },
    {
      title: "ID",
      dataIndex: "virtual_id",
      align: "center",
      render: (text, record) => {
        return <span> {record["ingredient"].virtual_id} </span>;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      render: (text, record) => {
        return (
          <Tag
            color={
              record.type === "subrecipe"
                ? "var(--greenColor)"
                : record.type === "inventory"
                ? "var(--blueColor)"
                : "var(--orangeColor)"
            }
          >
            {record["ingredient"].name}
          </Tag>
        );
      },
    },
    {
      title: "Qty",
      dataIndex: "qty",
      align: "center",
      render: (text, record) => {
        return <span> {record["total_enter_qty"]} </span>;
      },
    },
    {
      title: "Unit",
      dataIndex: "unit_id",
      align: "center",
      sorter: {
        compare: (a, b) => a.unit_id - b.unit_id,
      },
      render: (text, record) => {
        const result = ownCommonData.unitList.filter(
          (item) => item.id === record.unit_id
        );
        if (result.length === 0) {
          return "---";
        } else {
          return result[0].name;
        }
      },
    },
    {
      title: "Cost",
      dataIndex: "total_price",
      align: "center",
      sorter: {
        compare: (a, b) => a.total_price - b.total_price,
      },
      render: (text, record) => {
        return (
          <span>
            {"$(" + getCurrencyInfo() + ") " + record["total_price"]}{" "}
          </span>
        );
      },
    },
    {
      title: "Pre Instruction",
      dataIndex: "pre_instruction",
      align: "center",
      render: (text, record) => {
        return <span> {record["pre_instruction"]} </span>;
      },
    },
    {
      title: "Post Instruction",
      dataIndex: "post_instruction",
      align: "center",
      render: (text, record) => {
        return <span> {record["post_instruction"]} </span>;
      },
    },
    {
      title: "Procedure",
      dataIndex: "procedure",
      align: "center",
      render: (text, record) => {
        return <span> {record["procedure"]} </span>;
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <div size="middle" direction={"vertical"}>
            <a
              style={{ color: "var(--orangeColor)"}}
              className="edit-btn"
              onClick={async () => {
                handleEdit(record);
              }}
            >
              Edit
            </a>
            <a
              style={{ color: "var(--blueColor)" , marginLeft: 20}}
              className="del-btn"
              onClick={async () => {
                var res = await showConfirmDlgWidget({
                  title: "Delete Confirmation",
                  content: "Are you sure to delete this record?",
                });
                if (res == false) return;
                handleDelete(record);
              }}
            >
              Delete
            </a>
          </div>
        );
      },
    },
  ];

  const handleReorder = (dragIndex, draggedIndex) => {
    setDataSource((oldState) => {
      const newState = [...oldState];
      const item = newState.splice(dragIndex, 1)[0];
      newState.splice(draggedIndex, 0, item);
      //apiUpdateUserSiteItemMainSubPosition(newState);
      return newState;
    });
  };

  return (
    <div className="list-table">
      <Table
        size="middle"
        pagination={false}
        columns={columns}
        dataSource={dataSource}
      />
    </div>
  );
}

export default withRouter(RecipeAddTableWidget);
